import http from './http/http';
import {
    LOGIN_ENDPOINT,
    LOGOUT_ENDPOINT,
    SESSION_USER_ENDPOINT,
    SSO_ATTACH_URL,
} from './http/endpoints';
import { queryClient } from './api/query/queryClient';
import { clearLoadedImageUrls } from './photos/photoBySizeCache';
import { clearAllLocalUrls } from './photos/localImageUrlCache';

export const isLoggedIn = () => !!window.config.session_user;

export const isDeactivated = () =>
    !!window.config.session_user?.service_provider?.deactivated;

export const hasSignedLicences = () => {
    const licenceRecord = window.config.session_user.licence_record;
    return (licenceRecord?.eula_signed && licenceRecord?.terms_agreed) ?? false;
};

export const login = async (credentials) => {
    await attach();
    const { data } = await http.post(LOGIN_ENDPOINT, credentials);
    notifySessionUserChanged(data.data);
    return data.data;
};

export const logout = async () => {
    await attach();
    await http.post(LOGOUT_ENDPOINT);
    queryClient.clear();
    clearLoadedImageUrls();
    clearAllLocalUrls();
};

export const refreshSessionUser = async () => {
    const { data } = await http.get(SESSION_USER_ENDPOINT);
    const sessionUser = data.data;
    notifySessionUserChanged(sessionUser);
    return sessionUser;
};

export const notifySessionUserChanged = (sessionUser) => {
  window.config.session_user = sessionUser;
  window.dispatchEvent(new Event('session_user_updated'));
};

const attach = async () =>
    new Promise(async (resolve) => {
        if (!document.cookie.match('.*sso_token_.*')) {
            const res = await http.get(SSO_ATTACH_URL);
            const image = document.createElement('img');
            image.onload = resolve;
            image.src = res.data;
            document.body.appendChild(image);
        }
        resolve();
    });
